module.exports = __webpack_public_path__ + "img/已质疑.81bed2ce.png";